<template>
    <SideFormSection>
        <template #title> Basic Settings </template>
        <template #rawContent>
            <Card
                title="Basic Settings"
                iconName="gears"
            >
                <template #content>
                    <ApiForm
                        :url="
                            urlFactory.makeAutomationUpdateGeneralSettingsUrl(
                                automation.id,
                            )
                        "
                        method="POST"
                        ref="apiFormRef"
                    >
                        <AutomationGeneralSettingsForm
                            :automation="automation"
                            :errors="apiFormRef?.response?.getErrors() ?? null"
                        />
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Button from '@/Shared/Component/Button.vue'
    import Card from '@/Shared/Component/Card.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import Automation from '@/App/Automation/Entity/Automation'
    import AutomationGeneralSettingsForm from '@/App/Automation/Component/AutomationGeneralSettingsForm.vue'

    const emits = defineEmits<{
        onSuccess: [{ automation: Automation }]
    }>()

    const props = defineProps({
        automation: {
            type: Object as PropType<Automation>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)

    const submit = () => {
        apiFormRef.value?.submit()?.then((response: ApiFormResponseType) => {
            emits('onSuccess', {
                automation: response.getHydratedAutomation(
                    ResponseJsonKeyEnum.App_Automation_Update_AutomationData,
                ),
            })
        })
    }
    const urlFactory = new UrlFactory()
</script>
